module.exports = __webpack_public_path__ + "static/media/sale_01.af2a6285.svg";